"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.UNMIContractor = void 0;
var Tags_1 = require("../Tags");
var PreludeCard_1 = require("./PreludeCard");
var CardName_1 = require("../../CardName");
var CardRenderer_1 = require("../render/CardRenderer");
var UNMIContractor = (function (_super) {
    __extends(UNMIContractor, _super);
    function UNMIContractor() {
        return _super.call(this, {
            name: CardName_1.CardName.UNMI_CONTRACTOR,
            tags: [Tags_1.Tags.EARTH],
            metadata: {
                cardNumber: 'P34',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.tr(3).br;
                    b.cards(1);
                }),
                description: 'Increase your TR 3 steps. Draw a card.',
            },
        }) || this;
    }
    UNMIContractor.prototype.play = function (player) {
        player.increaseTerraformRatingSteps(3);
        player.drawCard();
        return undefined;
    };
    return UNMIContractor;
}(PreludeCard_1.PreludeCard));
exports.UNMIContractor = UNMIContractor;
